import { render } from "./StatisTiques.vue?vue&type=template&id=67c24a64"
import script from "./StatisTiques.vue?vue&type=script&lang=js"
export * from "./StatisTiques.vue?vue&type=script&lang=js"

import "./StatisTiques.vue?vue&type=style&index=0&id=67c24a64&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__